import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import { BreakPoints, media } from "../../helpers/rwd"
import { SectionWrapperStyles, SliderWrapperStyles } from "./game-list-styles"
import { colors } from "../../components/top-bar/core/colors"
import { mozillaFontAlignFix } from "../../helpers/mozilaFontAlignFix"


interface IContentWrapper {
  height: number | undefined
}

export const SectionWrapper = styled.div<{ background: string }>`
  background: ${({ background }) => background ? background : "rgba(0,0,0, .3)"};
  display: flex;
  position: relative;
  width: 100%;
  min-height: 613px;

  ${media.max(BreakPoints.phone)} {
    min-height: 460px;
  }

  ${SectionWrapperStyles}
`

export const SlideGameLabel = styled.div<{color: string}>`
  background: ${({color}) => color ? color : 'black'};
  width: auto;
  position: absolute;
  left: 0;
  top: 16px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 23px;
  text-align: center;
  color: ${colors.purple};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 4px 8px;
  ${mozillaFontAlignFix} {
    padding: 6px 8px 4px;
  }
  ${media.max(BreakPoints.phone)} {
    width: 267px;
    left: 50%;
    margin-left: -133px;
    top: 0px;
  }
`

export const SectionName = styled.h3`
  margin: 53px 0 31px 28px;
  font-weight: 700;
  font-size: 1.25em;
  text-transform: uppercase;

  ${media.max(BreakPoints.phone)} {
    margin: 31px 0 16px 8px;
  }

`

export const ContentWrapper = styled(GlobalContentWrapper)`
  display: flex;
  flex-direction: column;
  min-height: 400px;
  padding: 0;
  max-width: 1305px;
  z-index: 2;

  ${media.max(BreakPoints.lgDesktop)} {
    max-width: 1138px;
  }

  ${media.max(BreakPoints.desktop)} {
    max-width: 889px;
  }

  ${media.max(BreakPoints.smallDesktop)} {
    max-width: 645px;
  }
`
export const SliderWrapper = styled.div`
  margin: 1px ${media.max(BreakPoints.tablet)} {
    max-width: 645px;
  } ${SliderWrapperStyles} ${media.max(BreakPoints.lgDesktop)} {
    .slick-slider .slick-slide {
      padding: 0px 9px;
    }
  } ${media.max(BreakPoints.desktop)} {
    .slick-slider .slick-slide {
      padding: 0px 15px;
    }
  } ${media.max(BreakPoints.smallDesktop)} {
    .slick-slider .slick-slide {
      padding: 0px 28px;
    }
  }
`

export const HoverButtons = styled.div`
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  display: none;
  z-index: 3;
  ${media.max(BreakPoints.phone)} {
    width: 267px;
    left: 50%;
    margin-left: -135px;
  }
`

export const SlideGameLogo = styled.img`
  margin: auto auto 16px;
  width: 83%;
`

export const ButtonWrapper = styled.div`
  width: 83%;
  margin: 0 auto;
  padding: 13px 0 26px;

  a {
    width: 100%;
    min-width: auto;
  }
`

export const SlideWrapper = styled.div`
  display: flex !important;
  flex-direction: column !important;
  height: 379px;
  position: relative;
  transition: all .3s ease-in-out;

  ${media.max(BreakPoints.phone)} {
    height: 379px;
  }

  &:hover {
    .hidden-buttons {
      background: rgba(0, 0, 0, .5);
      display: block;
    }
  }

`

export const SlideBackground = styled.div<{ imgUrl: string }>`
  display: flex;
  flex-direction: column;
  position: relative;
  background: url(${({ imgUrl }) => imgUrl}) no-repeat center center;
  height: 100%;

  ${media.max(BreakPoints.phone)} {
    width: 265px;
    margin: 0 auto;
  }
`

export const SlideInformation = styled.div`
  margin-top: auto;
  background: black;
  padding: 13px;

  ${media.max(BreakPoints.tablet)} {
    background-position: center top;
  }

  ${media.max(BreakPoints.phone)} {
    background-size: 100%;
    background-position: center top;
    width: 94%;
  }
`

export const SlideTitle = styled.p`
  padding: 1px;
  margin: 1px;
  font-family: 'Motiva Sans', sans-serif;
  font-weight: 500;
  font-size: 1.05em;
  line-height: 1.5em;
`

export const SlideDescription = styled.p`
  padding: 1px;
  margin: 1px;
  color: #858585;
  font-size: 0.8em;
  line-height: 1.5em;
  font-family: 'Motiva Sans', sans-serif;
`
